<template>
  <Layout class="not-found-view">
    <template #body>
      <Card
        class="not-found-view__card"
        title="Página no encontrada"
      >
        <template #body>
          <div class="not-found-view__content">
            <p>La página {{ urlRef ? `"${urlRef}"` : '' }} solicitada no se ha podido encontrar.</p>
          </div>
        </template>
      </Card>
    </template>
  </Layout>
</template>

<script setup>
// #region VUE
import {
  shallowRef,
  inject,
  onMounted,
} from 'vue';
// #endregion

import {useRouter} from 'vue-router';

// #region COMPONENTS COMPOSABLES
import Layout from '@/components/layout/Layout.vue';
import Card from '@/components/card/Card.vue';
// #endregion

// #region Params, Ref, Reactives, Computed
const appState$$ = inject('appState$$');
const router = useRouter();
const urlRef = shallowRef((decodeURIComponent(router.currentRoute.value.query?.from || '')));
// #endregion

// #region Effects, Hooks
onMounted(async () => {
  appState$$.setLoginApp(false);
});
// #endregion
</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;
.not-found-view{
  height: 50vh;
  &__card{
    margin: 0 auto;
  }
  &__content{
    text-align: center;
    & p {
      @include media("<=phone") {
        font-size: $pv__fs--xlarge--phone;
      }
      @include media(">phone") {
        font-size: $pv__fs--xlarge;
      }
    }
  }
}
</style>
